import { ConvexReactClient } from 'convex/react';
import { CONVEX_URL } from './constants';

/**
 * Convex client singleton. Consumed by <ConvexProvider> in main.tsx.
 *
 * NOTE: The Convex functions module (`convex/_generated/api`) is created by
 * `npm run convex:dev` on first run and is git-ignored. Until that runs, imports
 * of `@/../convex/_generated/api` will fail. This module is safe either way —
 * it only constructs the client; it does not reference generated types.
 */
export const convex = new ConvexReactClient(CONVEX_URL || 'https://missing.convex.cloud');

/**
 * Whether the Convex URL was provided at build time. Used by AuthModal to
 * surface a helpful error if the app is deployed without env vars.
 */
export const isConvexConfigured = Boolean(CONVEX_URL);
